export default "__VITE_ASSET__CfVJumX3__"